import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { FilePreviewModule } from '../file-preview/file-preview.module';
import { FileComparisonDialogComponent } from './file-comparison-dialog.component';
import { IconModule } from 'src/app/components/icon/icon.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../button/button.module';
import { ButtonToggleGroupFormModule } from '../button-toggle-group-form/button-toggle-group-form.module';

@NgModule({
  declarations: [FileComparisonDialogComponent],
  exports: [FileComparisonDialogComponent],
  imports: [
    CommonModule,
    FilePreviewModule,
    ProgressSpinnerModule,
    IconModule,
    ReactiveFormsModule,
    ButtonModule,
    ButtonToggleGroupFormModule,
  ],
})
export class FileComparisonDialogModule {}
